Vue.component('campaign-preview', require('./CampaignPreview').default);
Vue.component('sms-preview', require('./SmsPreview').default);
Vue.component('email-preview', require('./EmailPreview').default);
